<div 
    class="modal fade" 
    [id]="modalId" 
    tabindex="-1" 
    role="dialog" 
    aria-labelledby="modelTitleId" 
    aria-hidden="true"
    >
    <div 
        *ngIf="info != null" 
        class="modal-dialog modal-sm modal-dialog-centered" 
        role="document"
        >
        <div 
            class="modal-content rounded" 
            [ngClass]="{'bg-dark': isDarkmode}"
            >
            <app-header-title
                closeButton="closeButtonDelete"
                [title]="info.title"
                [modalId]="modalId"
                >
            </app-header-title>
            <div 
                class="modal-body" 
                [ngClass]="{'white-text': isDarkmode}"
                >
                <div class="container">
                    <div class="row">
                        <div class="col-2 text-center align-self-center">
                            <i class="fa fa-trash fa-2x" aria-hidden="true"></i>
                        </div>
                        <div class="col-10 text-center">
                            <h4 
                                [ngClass]="{'white-text': isDarkmode}"
                                >{{info.body | translate}}
                            </h4>
                        </div>
                        <div class="col-12 text-center">
                            <h4 
                                [ngClass]="{'white-text': isDarkmode}"
                                >{{info?.body2 | translate}}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button 
                    type="button" 
                    class="btn btn-secondary" 
                    data-bs-dismiss="modal" 
                    (click)="setConfirmation(false)"
                    >{{info.cancelText | translate}}
                </button>
                <button 
                    type="button" 
                    class="btn btn-primary purple" 
                    data-bs-dismiss="modal" 
                    (click)="setConfirmation(true)"
                    >{{info.confirmText | translate}}
                </button>
            </div>
        </div>
    </div>
</div>